import { storage } from './storage.js';
export const createTenantClubSlice = (set) => ({
    tenantClub: null,
    setTenantClub: (context) => {
        // Persist to session storage for page refreshes
        storage.setItem('tenantClub', JSON.stringify(context), false);
        set({ tenantClub: context });
    },
    hydrateTenantClub: async () => {
        const raw = await storage.getItem('tenantClub');
        if (!raw)
            return;
        try {
            const parsed = JSON.parse(raw);
            if (!isTenantClubContext(parsed))
                return;
            set({ tenantClub: parsed });
        }
        catch {
            // ignore invalid JSON
        }
    },
    clearTenantClub: () => {
        storage.removeItem('tenantClub');
        set({ tenantClub: null });
    },
});
function isTenantClubContext(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return false;
    const rec = value;
    if (typeof rec.tenantId !== 'string' || typeof rec.clubId !== 'string')
        return false;
    // Validate optional string fields if present
    if (rec.courseId !== undefined && typeof rec.courseId !== 'string')
        return false;
    if (rec.courseIds !== undefined &&
        (!Array.isArray(rec.courseIds) || rec.courseIds.some((id) => typeof id !== 'string'))) {
        return false;
    }
    if (rec.courseNames !== undefined &&
        (!Array.isArray(rec.courseNames) || rec.courseNames.some((name) => typeof name !== 'string'))) {
        return false;
    }
    if (rec.clubTimezone !== undefined && typeof rec.clubTimezone !== 'string')
        return false;
    // clubCurrency can be string, null, or undefined
    if (rec.clubCurrency !== undefined &&
        rec.clubCurrency !== null &&
        typeof rec.clubCurrency !== 'string') {
        return false;
    }
    return true;
}
//# sourceMappingURL=tenantClubSlice.js.map